import ImagePerson from "@/components/functionals/ImagePerson.vue";
import HyperlinkForModuleAmonestacion from "@/components/functionals/HyperlinkForModuleAmonestacion.vue";

export default [
  {
    prop: "Name",
    label: "Empleado",
    sortable: true,
    formatter: ImagePerson,
    width: 200,
    attrs: {
      imgKey: "imageUrl"
    }
  },
  {
    prop: "Type",
    label: "Tipo",
    width: 140,
    sortable: true,
    formatter: (props) => {
      if (props.Type === 1) {
        return "Amonestacion";
      } else {
        return "Llamado Atencion";
      }
    }
  },
  {
    prop: "Enero",
    label: "Enero",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Febrero",
    label: "Febrero",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Marzo",
    label: "Marzo",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Abril",
    label: "Abril",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Mayo",
    label: "Mayo",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Junio",
    label: "Junio",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Julio",
    label: "Julio",
    sortable: true,
    width: 125,
    formatter: HyperlinkForModuleAmonestacion
  },

  {
    prop: "Agosto",
    label: "Agosto",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Septiembre",
    label: "Septiembre",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Octubre",
    label: "Octubre",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Noviembre",
    label: "Noviembre",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  },
  {
    prop: "Diciembre",
    label: "Diciembre",
    width: 125,
    sortable: true,
    formatter: HyperlinkForModuleAmonestacion
  }
];
